import { Lock, Users, Globe } from "lucide-react";
import Navbar from "@/components/Navbar";
import { ChannelCard } from "@/components/channels/ChannelCard";
import { ChannelIndex } from "@/components/channels/ChannelIndex";

const channels = [
  {
    title: "Private Channels",
    description: "Secure, internal collaboration for enterprises and organizations",
    icon: Lock,
    details: "Enable knowledge retention, workforce engagement, and operational efficiency",
    example: "Enterprises develop proprietary KBs to enhance internal AI systems",
    featured: [
      {
        name: "CURT",
        logo: "/lovable-uploads/fd68705c-c9c3-4382-92cb-e99499ecb0c2.png",
        link: "/curt-channel"
      },
      {
        name: "ExxonMobil Channel",
        logo: "/lovable-uploads/c48e4a04-76d3-44ce-af2f-005549765d3e.png",
        link: "/exxonmobil-channel"
      },
      {
        name: "Bechtel Channel",
        logo: "/lovable-uploads/2165ebae-a37b-42c5-9e9f-7874496c2348.png",
        link: "/bechtel-channel"
      },
      {
        name: "Oil and Gas",
        logo: "/lovable-uploads/8a556e19-9fef-436f-b2a4-9b96b85aaec9.png",
        link: "/oil-gas-channel"
      },
      {
        name: "GSA Channel",
        logo: "/lovable-uploads/df10ecaa-9f3a-46cf-abb2-7a3b51702fd3.png",
        link: "/gsa-channel"
      },
      {
        name: "Utthunga",
        logo: "/lovable-uploads/utthunga-logo.png",
        link: "/utthunga-channel"
      }
    ]
  },
  {
    title: "Semi-Private Channels",
    description: "Trusted collaborations between enterprises, vendors, or organizations",
    icon: Users,
    details: "Foster partnerships while protecting intellectual property",
    example: "Industry organizations enable members to co-create KBs on standards",
    featured: [
      {
        name: "Chevron-Microsoft-SLB Partnership",
        logo: "/lovable-uploads/2efcdd42-efcf-4712-b651-1970d7f303e5.png",
        link: "https://www.chevron.com/newsroom/2024/q4/the-power-of-collaboration-teaming-up-with-microsoft-slb"
      },
      {
        name: "Gulf Coast Growth Ventures",
        logo: "/lovable-uploads/710495ce-4786-4212-b8d2-7cf0ac746f54.png",
        link: "https://www.gulfcoastgv.com/"
      }
    ]
  },
  {
    title: "Public Channels",
    description: "Decentralized innovation for individuals and public teams",
    icon: Globe,
    details: "Drive innovation by developing KBs and solutions for market needs",
    example: "Teams create and market solutions addressing global challenges",
    featured: [
      {
        name: "Education",
        logo: "/placeholder.svg",
        link: "/education-channel"
      }
    ]
  }
];

const Channels = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-black mb-4">Consumption Channels</h1>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-8">
            Empowering Knowledge Networks for a Decentralized AI Future
          </p>
          <ChannelIndex />
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {channels.map((channel) => (
            <ChannelCard key={channel.title} {...channel} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Channels;
